import { useState } from "react";
import { Popover } from "@mui/material";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import ButtonIcon from "@/ui/ButtonIcon/ButtonIcon";
import { colorPrimary } from "@/constants/colors";
import { IIconWithPopupInfoProps } from "./IconWithPopupInfo.props";
import styles from "./IconWithPopupInfo.module.scss";

const IconWithPopupInfo = ({ children, icon = faCircleInfo, iconSize = "xl", iconColor = colorPrimary }: IIconWithPopupInfoProps): JSX.Element => {
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null); // якорь для окна информации

	const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>): void => {
		setAnchorEl(event.currentTarget);
	};

	const handlePopoverClose = (): void => {
		setAnchorEl(null);
	};

	return (
		<>
			{/* кнопка информации */}
			<ButtonIcon icon={icon} iconSize={iconSize} iconColor={iconColor} onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose} />

			{/* всплывающее окно */}
			<Popover
				sx={{ pointerEvents: "none" }}
				// sx={{ pointerEvents: "auto" }}
				open={Boolean(anchorEl)}
				onClose={handlePopoverClose}
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				disableRestoreFocus
				// PaperProps={{ onMouseEnter: handlePopoverOpen, onMouseLeave: handlePopoverClose }}
			>
				<div className={styles.info}>{children}</div>
			</Popover>
		</>
	);
};

export default IconWithPopupInfo;
